import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Base64Deriver from 'derivers/Base64';
import { isEmpty } from 'helpers/verify';
import { DefineVariables } from 'providers/ContextVariables';
import { CmsModuleShape } from 'containers/CmsPage/CmsModules';
import { ProductCard } from './cards/ProductCard';
import { SignupCard } from './cards/SignupCard';

export const PROPERTIES_TO_CHECK_FOR_OVERRIDES = [
  'callout',
  'calloutNote',
  'ctaCopy',
  'details',
  'disclaimer',
  'modules',
  'url',
];
export class ProductGroup extends Component {
  constructor(...args) {
    super(...args);
    this.CARD_RENDERER_BY_TYPE = {
      productcard: this.renderProductCard.bind(this),
      signupcard: this.renderSignupCard.bind(this),
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.msaId !== prevProps.msaId) {
      this.props.loadCardData({
        productType: this.props.productType,
        productCode: this.props.productCode,
      });
    }
  }

  getOfferUrl(offer) {
    const cardType = this.getCardType();
    const offerUrl =
      offer && cardType && cardType.toLowerCase() === 'signupcard'
        ? `/verify-phone/offer/${Base64Deriver.encode(offer.productId)}`
        : `/signup/offer/${Base64Deriver.encode(offer.productId)}`;
    return offerUrl;
  }

  getCardType() {
    const { isSupportedBrowser, shouldForceSignupCard } = this.props;
    if (shouldForceSignupCard) {
      return 'SignupCard';
    }
    if (isSupportedBrowser) {
      return this.props.cardType;
    }
    return 'ProductCard';
  }

  overridePropertiesWithCms(object, propertyList) {
    // Deep clone object to avoid mutating the original
    const objectCopy = object ? JSON.parse(JSON.stringify(object)) : {};
    const finalProperties = {};
    objectCopy.url = this.getOfferUrl(objectCopy);
    const updatedProperties = propertyList.reduce((acc, property) => {
      // Give preference to overrides from Contentful
      acc[property] = this.props[property] || objectCopy[property];
      return acc;
    }, finalProperties);
    const newObject = Object.assign(objectCopy, updatedProperties);
    return newObject;
  }

  selectCardRenderer(type) {
    const normalizedType = (type || '').toLowerCase();
    return this.CARD_RENDERER_BY_TYPE[normalizedType] || this.CARD_RENDERER_BY_TYPE.productcard;
  }

  checkForSingleOfferOverrides(offer) {
    return [this.overridePropertiesWithCms(offer, PROPERTIES_TO_CHECK_FOR_OVERRIDES)];
  }

  renderProductCard() {
    const { cmsModuleId, checkFirstOfferByDefault = true, offers, showMultipleOffers, tag: cmsTag } = this.props;
    const finalOffers = showMultipleOffers
      ? offers.map(o => ({ ...o, url: this.getOfferUrl(o) }))
      : this.checkForSingleOfferOverrides(offers[0]);
    return (
      <ProductCard
        offers={finalOffers}
        cmsModuleId={cmsModuleId}
        showMultipleOffers={showMultipleOffers}
        checkFirstOfferByDefault={checkFirstOfferByDefault}
        tag={cmsTag || finalOffers[0]?.tag}
      />
    );
  }

  renderSignupCard() {
    const { cmsModuleId, checkFirstOfferByDefault = false, offers, showMultipleOffers, tag: cmsTag } = this.props;
    const finalOffers = showMultipleOffers
      ? offers.map(o => ({ ...o, url: this.getOfferUrl(o) }))
      : this.checkForSingleOfferOverrides(offers[0]);
    return (
      <SignupCard
        offers={finalOffers}
        cmsModuleId={cmsModuleId}
        showMultipleOffers={showMultipleOffers}
        checkFirstOfferByDefault={checkFirstOfferByDefault}
        tag={cmsTag || finalOffers[0].tag}
      />
    );
  }

  render() {
    const { disclaimer, offers, msaId } = this.props;

    if (isEmpty(offers)) {
      return null;
    }

    const Card = this.selectCardRenderer(this.getCardType());

    return (
      <div className="ProductGroup">
        <div className="ProductGroup__cards">
          <DefineVariables variables={offers[0]?.contextVariables}>
            <Card key={msaId} />
          </DefineVariables>
        </div>
        {disclaimer && <p className="ProductGroup__disclaimer">{disclaimer}</p>}
      </div>
    );
  }
}

ProductGroup.propTypes = {
  callout: PropTypes.string,
  calloutNote: PropTypes.string,
  cardType: PropTypes.string,
  checkFirstOfferByDefault: PropTypes.bool,
  cmsModuleId: PropTypes.string.isRequired,
  ctaCopy: PropTypes.string,
  details: PropTypes.string,
  disclaimer: PropTypes.node,
  isSupportedBrowser: PropTypes.bool,
  loadCardData: PropTypes.func.isRequired,
  hasEmbeddedSignup: PropTypes.bool,
  modules: PropTypes.arrayOf(CmsModuleShape),
  msaId: PropTypes.number,
  offers: PropTypes.array.isRequired,
  productCode: PropTypes.string,
  productType: PropTypes.string,
  shouldForceSignupCard: PropTypes.bool,
  showMultipleOffers: PropTypes.bool,
  tag: PropTypes.string,
  url: PropTypes.string,
};
